<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <div style="padding-right:30px; border-bottom: 1px #eee solid; padding-bottom: 10px">
                <el-tabs v-model="activeName">
                  <el-tab-pane label="基础信息"
                               name="first">
                    <table class="table"
                           id="printJS-form">
                      <el-button style="margin-bottom:10px;position:absolute;right:0;top:-49px;"
                                 type="primary"
                                 size="small"
                                 @click="doPrint">打印</el-button>
                      <tr>
                        <th colspan="4">基础信息</th>
                      </tr>
                      <tr>
                        <th>项目名称</th>
                        <td>{{basisData.project_name}}（{{basisData.status_text}}）</td>
                        <th>项目类型</th>
                        <td>{{basisData.project_before_type_text}}</td>
                      </tr>
                      <tr>
                        <th>所属机构</th>
                        <td colspan="3">{{basisData.unit_name}}</td>
                      </tr>
                      <tr>
                        <th>项目起止时间</th>
                        <td>{{basisData.regdate_start}} 至 {{basisData.regdate_end}}（{{basisData.project_cycle?basisData.project_cycle+"个月":''}}）</td>

                        <th>预算金额</th>
                        <td>{{basisData.total_funds | setNumFormat}}</td>
                      </tr>

                      <tr>
                        <th>公益事务代表</th>
                        <td>{{basisData.resident_agent}}</td>
                        <th>项目对接人</th>
                        <td>{{basisData.group_leader}}</td>
                      </tr>

                      <!-- <tr>
                        <th>合作机构</th>
                        <td>
                          <p>{{basisData.cat_province+' '+basisData.cat_city}} {{basisData.cat_id_text}}</p>
                        </td>
                        <th>项目预算金额</th>
                        <td>{{basisData.total_funds}}</td>
                      </tr>-->

                      <tr>
                        <th>救助领域</th>
                        <td colspan="3">
                          <span v-for="(item,index) in basisData.salvage_ids "
                                :key="index"
                                style="margin-right:10px">{{item.salvage_text}}</span>
                        </td>
                      </tr>

                      <tr>
                        <th>覆盖地域</th>
                        <td colspan="3">{{addressText.join('、')}}</td>
                      </tr>

                      <tr>
                        <th>医保局备案：</th>
                        <td>{{basisData.if_medival_report == 1?'是':'否'}}</td>
                        <th>卫计委备案：</th>
                        <td>{{basisData.if_hygiene_report == 1?'是':'否'}}</td>
                      </tr>

                      <tr>
                        <th>{{basisData.if_medival_report == 1?'医保局备案信息：':'医保局备案计划：'}}</th>
                        <td colspan="3">{{basisData.if_medival_report == 1?basisData.medival_report_info:basisData.medival_report_plan}}</td>
                      </tr>

                      <tr>
                        <th>{{basisData.if_hygiene_report == 1?'卫计委备案信息：':'卫计委备案计划：'}}</th>
                        <td colspan="3">{{basisData.if_hygiene_report == 1?basisData.hygiene_report_info:basisData.hygiene_report_plan}}</td>
                      </tr>

                      <tr>
                        <th>项目预算：</th>
                        <td colspan="4">
                          <div class="tab-box">
                            <div class="tab-top">
                              <ul>
                                <li style="border-bottom:none;border-right:none;">费用项目</li>
                                <li style="width:70%;border-bottom:none;">单价(元)</li>
                              </ul>
                            </div>
                            <div class="tab-top">
                              <ul v-for="(item,index) in basisData.funds"
                                  :key="index">
                                <li style="border-bottom:none;border-right:none;">{{item.cost_item_text}}</li>
                                <li style="width:70%;border-bottom:none;">{{item.unit_text}}：{{item.funds_start | setNumFormat}}(元)-{{item.funds_end | setNumFormat}}(元)，资助人数{{item.total_number | setNumFormat(false)}}（人）</li>
                              </ul>
                            </div>
                            <div class="tab-top">
                              <ul>
                                <li style="border-right:none;">救助对象：</li>
                                <li style="width:70%;">{{basisData.fund_use}}</li>
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <th>协议盖章</th>
                        <td colspan="4"
                            v-if="basisData.agree_stamp && basisData.agree_stamp[0]">
                          <!-- <viewer :images="basisData.agree_stamp" v-if="basisData.agree_stamp">
                            <img
                              v-for="(item,index) in basisData.agree_stamp"
                              :src="item.pic_path"
                              :key="index"
                              style="width: 50px; height: 50px;cursor: pointer;margin-right:5px"
                            />
                            <p style="clear: both; padding-top: 10px">
                              <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击上方图片查看/下载大图
                            </p>
                          </viewer>-->

                          <a v-for="item in basisData.agree_stamp"
                             :key="item.id"
                             style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4;margin-right:10px"
                             :href="item.url">{{ item.name }}</a>
                          <p style="clear: both; padding-top: 10px">
                            <i class="el-icon-info"
                               size="18"
                               style="clear: both;"></i>
                            &nbsp;点击文件名进行预览
                          </p>
                        </td>
                        <td colspan="4"
                            v-else
                            style="color:red">暂未进行协议盖章~</td>
                      </tr>
                    </table>
                  </el-tab-pane>
                  <el-tab-pane label="项目执行计划"
                               name="second">
                    <el-row type="flex"
                            justify="center"
                            style="padding:10px">
                      <el-col :span="20">
                        <p v-if="basisData.payment && basisData.payment.plan.length>0"
                           style="margin-bottom: 15px;">结算计划：</p>
                        <el-table v-if="basisData.payment && basisData.payment.plan.length>0"
                                  border
                                  :data="basisData.payment.plan"
                                  style="width: 100%"
                                  class="tables"
                                  label-width="220px">
                          <el-table-column type="expand">
                            <template slot-scope="props">
                              <el-form label-position="left"
                                       label-width="auto"
                                       inline
                                       class="demo-table-expand">
                                <el-form-item label="计划捐款日期">
                                  <span>{{props.row.plan_time}}</span>
                                </el-form-item>
                                <el-form-item label="计划捐款金额">
                                  <span>{{props.row.plan_money | setNumFormat}}</span>
                                </el-form-item>

                                <el-form-item label="捐款状态">
                                  <span>
                                    {{props.row.hospital_payment_status_text}}
                                    <span v-if="props.row.money">{{'（捐款'+props.row.money | setNumFormat+'元）'}}</span>
                                  </span>
                                </el-form-item>

                                <el-form-item label="基金会确认状态">
                                  <span>{{props.row.foundation_receipts_status_text}}</span>
                                </el-form-item>

                                <el-form-item label="本次捐款金额">
                                  <span>{{props.row.allocation_money | setNumFormat}}</span>
                                </el-form-item>

                                <template v-if="props.row.hospital_payment_status == 1">
                                  <el-form-item label="本次捐款凭证"
                                                v-if="props.row.allocation_pic_path &&  props.row.allocation_pic_path.length > 0">
                                    <viewer :images="props.row.allocation_pic_path">
                                      <img :src="item.url"
                                           alt
                                           v-for="item in props.row.allocation_pic_path"
                                           style="width:50px;height:50px" />
                                    </viewer>
                                  </el-form-item>
                                </template>

                                <template v-if="props.row.foundation_receipts_status == 1">
                                  <el-form-item label="基金会确认金额">
                                    <span>{{props.row.return_money}}</span>
                                  </el-form-item>

                                  <el-form-item label="基金会确认时间">
                                    <span>{{props.row.return_time}}</span>
                                  </el-form-item>
                                </template>
                              </el-form>
                            </template>
                          </el-table-column>
                          <el-table-column label="计划捐款日期"
                                           width="400"
                                           prop="plan_time">
                            <template slot-scope="scope">
                              <!-- <span
                                v-if="(strToTime(scope.row.plan_time) <= Date.parse(new Date())) && scope.row.hospital_payment_status == 2"
                                style="color:red"
                              >{{scope.row.plan_time}}（已逾期）</span> -->
                              <span>{{scope.row.plan_time}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="计划捐款金额"
                                           min-width="200"
                                           prop="plan_money">
                            <template slot-scope="scope">
                              {{scope.row.plan_money | setNumFormat}}
                            </template>
                          </el-table-column>
                          <el-table-column label="捐款状态"
                                           min-width="200"
                                           prop="hospital_payment_status_text"></el-table-column>
                          <el-table-column label="确认状态"
                                           min-width="200"
                                           prop="foundation_receipts_status_text"></el-table-column>
                        </el-table>
                      </el-col>
                    </el-row>

                    <!-- <el-row type="flex" justify="center" style="padding:10px">
                      <el-col :span="20">
                        <p style="margin-bottom: 15px;">回款信息</p>
                        <el-table :data="basisData.return.plan" border>
                          <el-table-column prop="return_time" label="回款日期" align="center"></el-table-column>
                          <el-table-column prop="return_money" label="回款金额" align="center"></el-table-column>
                          <el-table-column prop="return_remark" label="备注" align="center"></el-table-column>
                          <el-table-column prop="return_pic_path" label="凭证" align="center">
                            <template slot-scope="scope">
                              <viewer :images="scope.row" v-if="scope.row.length > 0">
                                <img
                                  v-for="item in scope.row"
                                  :src="item.url"
                                  :key="'pic'+item.id"
                                  style="width: 50px; height: 50px;cursor: pointer;margin-right:5px"
                                />
                                <p style="clear: both; padding-top: 10px">
                                  <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击上方图片查看/下载大图
                                </p>
                              </viewer>
                            </template>
                          </el-table-column>
                        </el-table>
                      </el-col>
                    </el-row>-->

                    <el-row type="flex"
                            justify="center"
                            style="padding:10px"
                            v-if="basisData.project_before_type == 1">
                      <el-col :span="20">
                        <p style="margin-bottom: 15px;">月度项目执行计划表：</p>
                        <el-table :data="basisData.plan_content"
                                  border>
                          <el-table-column prop="month"
                                           label="日期"
                                           align="center"></el-table-column>
                          <el-table-column prop="number"
                                           label="筛查人数"
                                           align="center"></el-table-column>
                          <el-table-column prop="case"
                                           label="救助例数"
                                           align="center"></el-table-column>
                        </el-table>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                  <el-tab-pane label="媒体报告"
                               name="third">
                    <!-- 媒体报告开始 -->
                    <el-row type="flex"
                            justify="center"
                            style="padding:10px">
                      <el-col :span="20"
                              v-if="mediaData && mediaData.length>0">
                        <p style="margin-bottom: 15px;">媒体报道列表：</p>
                        <el-table border
                                  :data="mediaData"
                                  :row-key="row_key_media"
                                  :expand-row-keys="expandRowKeysMedia"
                                  style="width: 100%"
                                  class="tables">
                          <el-table-column type="expand">
                            <template slot-scope="props">
                              <el-form label-position="left"
                                       inline
                                       class="demo-table-expand">
                                <el-form-item label="媒体报道标题">
                                  <span>{{props.row.title}}</span>
                                </el-form-item>
                                <!-- <el-form-item label="媒体报道视频">
                                  <span
                                    @click="downFile(props.row.vedio, props.row.vedio_name)"
                                    style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                                  >{{ props.row.vedio_name }}</span>
                                </el-form-item>-->
                                <el-form-item label="媒体报道级别">
                                  <span>{{ props.row.level_text }}</span>
                                </el-form-item>
                                <el-form-item label="媒体报道类型">
                                  <span>{{ props.row.type_text }}</span>
                                </el-form-item>
                                <el-form-item label="媒体报道图片">
                                  <viewer :images="props.row.pic_url"
                                          v-if="props.row.pic_url && props.row.pic_url.length>0">
                                    <img v-for="value in props.row.pic_url"
                                         :src="value"
                                         :key="value"
                                         style="width: 50px; height: 50px;cursor: pointer;margin-right:5px" />
                                    <p style="clear: both; padding-top: 10px">
                                      <i class="el-icon-warning"
                                         size="18"
                                         style="clear: both;"></i>&nbsp;点击上方图片查看/下载大图
                                    </p>
                                  </viewer>
                                </el-form-item>
                                <el-form-item label="媒体报道链接地址">
                                  <span v-if="props.row.url">
                                    <a :href="props.row.url?props.row.url:'javascript:;'"
                                       target="_blank"
                                       style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 ">{{ props.row.url }}</a>
                                  </span>
                                </el-form-item>
                                <el-form-item label="媒体报道附件">
                                  <!-- <span
                                    @click="downFile(props.row.file, props.row.file_name)"
                                    style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                                  >{{ props.row.file_name }}</span>-->
                                  <a :href="props.row.file_url"
                                     target="_blank">{{props.row.file_name}}</a>
                                </el-form-item>
                                <el-form-item label="媒体报道说明">
                                  <span>{{ props.row.description }}</span>
                                </el-form-item>
                              </el-form>
                            </template>
                          </el-table-column>
                          <el-table-column label="媒体报道标题"
                                           width="400"
                                           prop="title"></el-table-column>
                          <el-table-column label="报道级别"
                                           min-width="200"
                                           prop="level_text"></el-table-column>
                          <el-table-column label="添加时间"
                                           min-width="200"
                                           prop="addtime"></el-table-column>
                        </el-table>
                      </el-col>
                      <el-col :span="20"
                              v-else>
                        <p style="clear: both;font-size:14px;color:#ccc;text-align:center">暂无数据
                        </p>
                      </el-col>
                    </el-row>
                    <!-- 媒体报告结束 -->
                  </el-tab-pane>
                  <el-tab-pane label="结项信息"
                               name="fourth"
                               v-if="nodeShow">
                    <table class="tablePost">
                      <div v-if="postData">
                        <tr>
                          <td>申请人 :{{postData.apply_user_name}}</td>
                        </tr>
                        <tr>
                          <td>申请时间 :{{postData.reg_time}}</td>
                        </tr>
                        <tr>
                          <td>结项时间 :{{postData.node_time}}</td>
                        </tr>
                        <tr>
                          <td>
                            结项附件 :
                            <!-- <span
                              @click="downFile(postData.file_id, postData.file_source_name)"
                              style="text-decoration: underline; color: #333; cursor: pointer;color:#4682B4 "
                            >{{postData.file_source_name}}</span>-->
                            <a :href="postData.file_url"
                               target="_blank">{{postData.file_name}}</a>
                          </td>
                        </tr>
                        <tr>
                          <td>结项原因 :{{postData.reasons}}</td>
                        </tr>
                        <tr>
                          <td>
                            项目摘要：
                            <span class="span_box">
                              本项目自
                              <i>{{abstract.regdate_start}}</i>至
                              <i>{{abstract.regdate_end}}</i> 的实施期间，累计受益总人数为
                              <i>{{abstract.beneficiary_number}}</i>，其中筛查
                              <i>{{abstract.screen_sum}}</i>人，
                              筛查出的患者中有
                              <i>{{abstract.apply_count}}</i>名入院复诊接受治疗，合计使用该项目款
                              <i>{{abstract.approve_sum}}</i> 元，此外医保补助总额为
                              <i>{{abstract.yb_sum}}</i> 元。
                            </span>
                          </td>
                        </tr>
                      </div>
                      <div v-else>
                        <p style="clear: both;font-size:14px;color:#666;">
                          <i class="el-icon-warning"
                             size="18"
                             style="clear: both;"></i>&nbsp;暂无数据
                        </p>
                      </div>
                    </table>
                  </el-tab-pane>
                  <el-tab-pane label="阶段报告"
                               name="fifth">
                    <report-list :pid="$route.query.id"
                                 v-if="activeName == 'fifth'"></report-list>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import reportList from "./report_info";
import Print from "print-js";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    reportList
  },
  data () {
    return {
      defaultMsg1: "",
      defaultMsg2: "",
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 300,
        scaleEnabled: true
      },

      abstract: {}, //项目相关金额

      addressText: [], //实施地点地址
      editorOption: {},
      activeName: "first",
      id: "", //项目id
      basisData: { agree_stamp: [] }, //基础信息
      paymentData: [], //执行机构捐款情况
      applyData: [], //执行机构申请捐款
      mediaData: [], //媒体报道
      expandRowKeys: [],
      expandRowKeysMedia: [],
      postData: {}, //结项信息
      nodeShow: false,

      province: [], //省
      city: [], //市
      county: [], //县
      fundsTypeData: [] //资金类型
    };
  },
  computed: {},
  methods: {
    //查看救助记录
    getApplyList () { },

    strToTime (str) {
      let time;
      // 转换日期格式
      str = str.replace(/-/g, "/"); // "2010/08/01";
      // 创建日期对象
      var date = new Date(str);
      // 加一天 不加
      time = date.setDate(date.getDate() + 1);

      return time;
    },

    //打印
    doPrint () {
      // 自定义打印样式
      const style =
        '@page { size: A4 portrait; margin: 10% 5%; } @media print {.table td,.table th{border:1px solid #ccc}.table th{width: 15%;min-width: 120px;padding: 20px 5px;font-weight: 300;font-size: 14px;text-align: center;}  .disc{height: 100px;}.table td{padding: 20px 5px;font-size: 12px;font-family: "微软雅黑";font-weight: 100;text-align: left;min-width: 80px}.table {margin:20px auto;max-width: 900px !important;width: calc(100% - 40px);border:0; border-collapse:collapse;}tab-box{width: 100%;padding-left:-20px;}tab-box>.tab-top>ul {display:flex;} .tab-box > .tab-top > ul > li{width: 25%;height:21px;border: 1px solid #bbb;padding: 10px 0;text-align: center;list-style: none;float: left;}.tab-box >.tab-top > ul > li:first-child{border-right:none;}.tab-box > .tab-bottom > .list-box {border-top: none;}.tab-box > .tab-bottom > .list-box > span {width: 30%;padding: 10px 0;text-align: center;border-top: none;}.tab-box > .tab-bottom > .list-box > p {float: left;border: 1px solid #bbb;padding: 10px 0;text-align: center;border-top: none;}.text-box {border: 1px solid red;border-top: none;position: relative;height: 100%;}}';
      Print({
        printable: "printJS-form",
        type: "html",
        style: style,
        scanStyles: false
      });
    },
    onEditorReady (editor) { },
    row_key (row) {
      return row.apply_pay_id;
    },
    row_key_media (row) {
      return row.id;
    },
    //下载文件
    downFile (id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download (data, name) {
      if (!data) {
        return;
      }

      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //获取项目摘要（结项资料）
    getAbstract () {
      this.$db
        .post(this.$db.config.getProjectPublicNodeTotal, {
          id: this.$route.query.id
        })
        .then(res => {
          if (res && res.code == 200) {
            this.abstract = res.data;
          }
        });
    }
  },
  mounted () {
    //  this.$parent.setUEContent();
    let loading = this.$loading({
      text: "数据正在加载中……"
    });
    this.id = this.$route.query.id;
    //基础信息
    this.$db
      .post(this.$db.config.publicComProjectInfoDetails, { id: this.id })
      .then(res => {
        if (res.code == 200) {
          this.basisData = res.data;
          loading.close();
          if (this.basisData.address && this.basisData.address.length > 0) {
            this.basisData.address.forEach(item => {
              this.addressText.push(
                (item.province ? item.province : "") +
                (item.city ? "/" + item.city : "") +
                (item.county ? "/" + item.county : "")
              );
            });
          } else {
            this.addressText[0] = "不限制覆盖地域";
          }
        }
      });
    //执行机构捐款情况
    this.$db
      .post(this.$db.config.publicComProjectInfoFunds, { id: this.id })
      .then(res => {
        if (res.code == 200) {
          this.paymentData = res.data;
        }
      });

    //执行机构申请拨款
    this.$db
      .post(this.$db.config.publicComProjectInfoApplyPay, { id: this.id })
      .then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.applyData = res.data;
            this.expandRowKeys.push(this.applyData[0].apply_pay_id);
          }
        }
      });
    //媒体报告列表
    this.$db
      .post(this.$db.config.mediaCoverageList, {
        project_id: this.id,
        project_type: 1
      })
      .then(res => {
        if (res.code == 200) {
          if (res.data.data.length > 0) {
            this.mediaData = res.data.data;
            this.expandRowKeysMedia.push(this.mediaData[0].id);
          }
        }
      });
    //结项信息
    this.$db
      .post(this.$db.config.publicComProjectInfoNodeDetails, { id: this.id })
      .then(res => {
        if (res.code == 200) {
          if (res.data.constructor !== Array) {
            if (res.data.apply_user_name) {
              this.postData = res.data;
              this.nodeShow = true;
            } else {
              this.nodeShow = false;
            }

          }

          this.getAbstract();
        }
      });
    //资金类型
    this.$db
      .post(this.$db.config.getDictParam, { pid: 200104, table: "pub_dict" })
      .then(res => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            this.fundsTypeData[item.value] = item.text;
          });
        }
      });
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      padding-left: 40px;
    }
  }
}
.el-tab-pane {
  color: #666;
}
.table td,
.table th {
  border: 1px solid #ccc;
}

.table th {
  width: 15%;
  min-width: 100px;
  padding: 20px 5px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}
.disc {
  height: 100px;
}

.table td {
  padding: 20px 5px;
  font-size: 14px;
  font-family: "微软雅黑";
  font-weight: 100;
  text-align: left;
  min-width: 80px;
  max-width: 133px;
}
.table {
  margin: 50px auto;
  max-width: 900px !important;
  width: calc(100% - 10px);
  border: 0;
  border-collapse: collapse;
  position: relative;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand-lable {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 48%;
}
.tab-box {
  width: 100%;
}
.tab-box > .tab-top > ul {
  display: flex;
}
.tab-box > .tab-top > ul > li {
  width: 30%;
  border: 1px solid #bbb;
  padding: 10px 0;
  text-align: center;
}
// .tab-box > .tab-tops > ul > li:first-child {
//   border-right: none;
// }
// .tab-box > .tab-tops > ul {
//   display: flex;
// }
// .tab-box > .tab-tops > ul > li {
//   width: 30%;
//   border: 1px solid #bbb;
//   padding: 10px 0;
//   text-align: center;

// }
// .tab-box > .tab-tops > ul > li:first-child {
//   border-right: none;
// }
.tab-box > .tab-bottom > .list-box {
  display: flex;
  // border: 1px solid #bbb;
  border-top: none;
}
.tab-box > .tab-bottom > .list-box > span {
  width: 30%;
  padding: 10px 0;
  text-align: center;
  border-top: none;
}
.tab-box > .tab-bottom > .list-box > p {
  border: 1px solid #bbb;
  padding: 10px 0;
  text-align: center;
  border-top: none;
}
.text-box {
  display: flex;
  border: 1px solid #bbb;
  border-top: none;
  position: relative;
  height: 100%;
}
.text-box > p {
  width: 30%;
  color: #333;
  text-align: center;
  position: relative;
  > i {
    font-style: normal;
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.text-box > .content-box {
  width: 70%;
  border-left: 1px solid #bbb;
}
.text-box > .content-box > p {
  font-size: 14px;
  color: #333;
  padding: 10px;
}
.tablePost {
  width: calc(100% - 100px);
  margin: 20px 50px;
}
.tablePost td {
  width: 50%;
  max-width: 50%;
  border-bottom: 1px dashed #eee;
  padding: 18px 0;
  color: #666;
  font-size: 14px;
}
.tables /deep/ .el-form--inline .el-form-item__label {
  color: #99a9bf;
}
// .edit_container /deep/ .ql-editor{
//   min-height: 200px !important;
// }
.edit_container {
  line-height: 24px;
}
// .quill-editor {

//     height: 100px;
// }
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/info.vue